"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__753a9e10a",
  width: 20,
  height: 20,
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm0 3.405c-1.22 0-2.232.977-2.232 2.208a.7.7 0 1 0 1.4 0A.82.82 0 0 1 10 7.805a.82.82 0 0 1 .832.81c0 .138-.04.225-.097.302a1.39 1.39 0 0 1-.348.296c-.43.285-1.088.801-1.088 1.79v.189a.7.7 0 1 0 1.4 0v-.188c0-.146.04-.238.101-.318.072-.096.187-.19.36-.306.42-.279 1.072-.789 1.072-1.766 0-1.23-1.01-2.209-2.232-2.209ZM9.2 13.1a.791.791 0 0 1 .795-.8.8.8 0 1 1-.795.8Z",
  clipRule: "evenodd",
  mask: "url(#ursa-icon__753a9e10a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HelpFillIcon20.js.map